export const MAX_RECOMMENDATIONS = 3;
export const EMPTY_STATE_ICON = '🎯';
